import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { FlyoverBuilder } from '../Flyover/FlyoverBuilder';
import { Menu } from '../Menu';
export function Dropdown(props) {
  var options = props.options,
    flyoverProps = _objectWithoutProperties(props, ["options"]);
  return /*#__PURE__*/React.createElement(FlyoverBuilder, _extends({}, flyoverProps, {
    closeOnFlyoverClick: true,
    toggleOnClick: true,
    enableScrollY: true,
    flyover: /*#__PURE__*/React.createElement(Menu, {
      items: options
    })
  }));
}